import { toast } from '../../shared/toast-notifications';
import { NotificationType } from '../../../utils/enums';

export const toastSuccessUpdateManageApp  = () => toast(NotificationType.SUCCESS,
    'Your managed apps list was updated successfully');
